import { h, s } from '../lib/dom';

interface Pillar {
  num: string;
  title: string;
  glyph: () => SVGSVGElement;
}

const PILLARS: Pillar[] = [
  {
    num: '01',
    title: 'Research',
    glyph: () => glyph(
      s('circle', { cx: 28, cy: 28, r: 12, fill: 'none', stroke: 'currentColor', 'stroke-width': 1.4 }),
      s('path', { d: 'M37 37 L48 48', stroke: 'currentColor', 'stroke-width': 1.6, 'stroke-linecap': 'round' }),
      s('circle', { cx: 28, cy: 28, r: 3, fill: '#FF9933' }),
    ),
  },
  {
    num: '02',
    title: 'Technology',
    glyph: () => glyph(
      s('rect', { x: 8, y: 14, width: 40, height: 28, rx: 4, fill: 'none', stroke: 'currentColor', 'stroke-width': 1.4 }),
      s('path', { d: 'M18 48 H38', stroke: 'currentColor', 'stroke-width': 1.4, 'stroke-linecap': 'round' }),
      s('circle', { cx: 28, cy: 28, r: 3, fill: '#138808' }),
    ),
  },
  {
    num: '03',
    title: 'Policy',
    glyph: () => glyph(
      s('path', { d: 'M14 44 V20 L28 12 L42 20 V44 Z', fill: 'none', stroke: 'currentColor', 'stroke-width': 1.4, 'stroke-linejoin': 'round' }),
      s('path', { d: 'M22 44 V30 H34 V44', fill: 'none', stroke: 'currentColor', 'stroke-width': 1.4 }),
      s('circle', { cx: 28, cy: 22, r: 2.4, fill: '#06038D', stroke: '#fff', 'stroke-width': 1 }),
    ),
  },
];

function glyph(...children: SVGElement[]): SVGSVGElement {
  const svg = s('svg', {
    xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 56 56',
    width: 56, height: 56, class: 'glyph', 'aria-hidden': 'true',
  });
  children.forEach((c) => svg.append(c));
  return svg;
}

export function renderPillars(): HTMLElement {
  const grid = h('div', { class: 'grid grid-3' });
  for (const p of PILLARS) {
    grid.append(
      h('article', { class: 'pillar reveal' },
        p.glyph(),
        h('span', { class: 'num' }, p.num),
        h('h3', {}, p.title),
      ),
    );
  }

  return h('section', { 'aria-label': 'Work' },
    h('div', { class: 'container' }, grid),
  );
}
